import {
  businessPrincipleList,
  communicationSkillList,
  peerDescriptionList,
} from "@/redux/features/candidateProfileSlice";
import { z } from "zod";

const schema = z.object({
  questionnaireBusinessPrinciples: z
    .enum(businessPrincipleList)
    .array()
    .optional(),
  questionnairePeerDescription: z.enum(peerDescriptionList).array().optional(),
  questionnaireCommunicationSkills: z
    .enum(communicationSkillList)
    .array()
    .optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateQuestionnaireFormSchema,
  type Schema as CandidateQuestionnaireFormSchema,
};
